import React from 'react';

import { Modal } from 'src/components/common';
import { InviteVerifierStaffModalForm } from 'src/components/verifierStaff';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { InviteVerifiersManagersByCVAdminModalArgs } from './types';

export const InviteVerifiersStaffByCVAdminModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<InviteVerifiersManagersByCVAdminModalArgs>(ModalId.InviteVerifiersStaffByCVAdmin);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  if (isOpen && !args?.verifierId) {
    throw new Error('"verifierId" is required');
  }

  return (
    <Modal
      title="Invite Verifier Staff"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      headerPadding="32px 32px 4px"
      headerProps={{
        sx: {
          lineHeight: '28px',
        },
      }}
      contentProps={{
        sx: {
          pt: 0,
        },
      }}
    >
      <InviteVerifierStaffModalForm
        verifierId={String(args?.verifierId)}
        isDisabled={args?.isDisabled}
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
